import image1 from "../offer_section_images/img_001.jpg";
import image2 from "../offer_section_images/img_002.jpg";
import image3 from "../offer_section_images/img_003.jpg";
import image4 from "../offer_section_images/img_004.jpg";
import image5 from "../offer_section_images/img-005.jpg";
import image6 from "../offer_section_images/img_006.jpg";

export const images = [image1, image2, image3, image4, image5, image6];
